import React from "react";
import {useTranslation} from "react-i18next";

import ProgressiveImage from "components/atoms/ProgressiveImage";
import Title from "components/atoms/TitleTemplate";
import ItemBlock from "./ItemBlock";

import {png} from "assets/png";
import "./style.scss"

const EcoModular = () => {
    const {t} = useTranslation()

    return (
        <section className="economy_modular container">
            <Title underline={true}>{t("gameEconomyCustomizationTitlePartOne")} <span>{t("gameEconomyCustomizationTitlePartTwo")}</span></Title>
            <div className="economy_modular_content">
                <ItemBlock
                    reverse={true}
                    background={false}
                    className="item-one"
                    orgImage={png.HeroIndividual5Png}
                    noOrgImage={png.HeroIndividual5Webp}
                    title={t("gameEconomyCustomizationArticle1Title")}
                >
                    {t("gameEconomyCustomizationArticle1Description")}
                </ItemBlock>
                <div className="row-left-img item-two">
                    <div>
                        <ProgressiveImage imgSrc={png.BazaarCosmeticsPng} previewSrc={png.BazaarCosmeticsWebp}/>
                    </div>
                    <div>
                        <h2>{t("gameEconomyCustomizationArticle2Title")}</h2>
                        <p>{t("gameEconomyCustomizationArticle2Description")}</p>
                    </div>
                </div>
                <div className="row-right-img item-three">
                    <div>
                        <h2>{t("gameEconomyCustomizationArticle3Title")}</h2>
                        <p>{t("gameEconomyCustomizationArticle3Description")}</p>
                    </div>
                    <div>
                        <ProgressiveImage imgSrc={png.RarityComponentsPng} previewSrc={png.RarityComponentsWebp}/>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default EcoModular

